import { components, OptionProps } from 'react-select';
import { GenericDropdownOption } from 'App.types';
import { creatorbase } from '@round/api';
import React from 'react';

import FinanceStatusBadge from './FinanceStatusBadge';

type Props<TIsMulti extends boolean> = OptionProps<GenericDropdownOption<creatorbase.FinanceStatus>, TIsMulti>;

const FinanceStatusBadgeOption = <TIsMulti extends boolean>(props: Props<TIsMulti>) => (
    <components.Option {...props}>
        <FinanceStatusBadge financeStatus={props.data.value} />
    </components.Option>
);

export default FinanceStatusBadgeOption;
